import userauth from '~/helpers/userauth'

export default (to, from, next) => {
    var orgId = to.params.id;
    if (!userauth.isOrgManager(orgId)) {
        next({name: 'dashboard'})
    } else {
        next()
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/org-manager.js